import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";

export default function HealthCareBlogList() {
  const location = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState(() => {
    return (
      location.state?.blogHr || JSON.parse(localStorage.getItem("blogData"))
    );
  });

  useEffect(() => {
    if (data) {
      localStorage.setItem("blogData", JSON.stringify(data));
    }
  }, [data]);

  const handleNavigate = () => {
    navigate(-1);
  };

  const handleDetailAffiliations = (hrBlogList) => {
    navigate(`/warehouse/hr/blog-list/blog-detail/${hrBlogList?.id}`, {
      state: { blog: hrBlogList, topic: data },
    });
  };

  return (
    <>
      <div className="container-fluid position-relative">
        {/* <div className="circle-background"></div> */}
        <div className="d-flex mt-3">
          <div className="heading-main ">
            <h2>{data?.name} Blogs</h2>
          </div>
        </div>

        <Carousel
          interval={3000}
          pause={false}
          controls={true}
          indicators={true}
        >
          {(data?.whyItMatters || []).slice(0, 3).map((blog, index) => (
            <Carousel.Item key={index}>
              <div className="container row d-flex align-items-center carousel-item-container">
                <div className="col-md-6 p-2">
                  <div
                    className="blog-card shadow p-4 ms-4 heading-h3"
                    style={{
                      // height: "297px",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "-center",
                      flexDirection: "column",
                    }}
                  >
                    <h3 className="mb-4">{blog?.title}</h3>
                    <p>{blog?.description}</p>
                    <div style={{ display: "flex", justifyContent: "end" }}>
                      <button
                        className="small-button-cotain-view-all "
                        onClick={() => handleDetailAffiliations(blog)}
                      >
                        Read More
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 ">
                  <img
                    className="d-block w-100 card-img"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "10px",
                    }}
                    src={blog?.image || data?.logo}
                    alt={blog?.title}
                  />
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
      <div
        className="row g-4 mt-2"
        style={{ marginLeft: "10px", marginRight: "10px" }}
      >
        {[...(data?.whyItMatters || []), ...(data?.bestPractices || [])].map(
          (blog, index) => (
            <div
              key={index}
              className="col-6 col-sm-4 col-md-3 custom-col-5 mt-3 d-flex "
            >
              <div className="card d-flex flex-column h-100 shadow-sm">
                <img
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDetailAffiliations(blog)}
                  src={blog?.image || data?.logo}
                  alt={blog?.name}
                  className="card-img-top p-0"
                />
                <div className="card-body flex-grow-1 d-flex flex-column card-content-partners">
                  <h5 className="card-title">{blog?.title}</h5>
                  <p className="card-text">{blog?.description}</p>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </>
  );
}
